import 'rxjs/add/operator/filter'; // otherwise you can't use filter in this repo...
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import * as actions from './actions'
import * as meetingApi from './api'

const fetchCalendarStatusEpic = action$ =>
  action$.ofType(actions.fetchCalendarStatus.toString()).mergeMap(() => {
    return Observable.fromPromise(meetingApi.fetchCalendarStatus())
      .map(response => actions.fetchCalendarStatusSuccess(response))
      .startWith(actions.fetchCalendarStatusPending())
      .catch(error => Observable.of(actions.fetchCalendarStatusFailure()))
  })

const triggerFetchGoogleCalendarsEpic = action$ =>
  action$
    .ofType(actions.fetchCalendarStatusSuccess.toString())
    .filter(action => action.payload.googleAuthed)
    .map(() => actions.fetchGoogleCalendars())

const fetchGoogleCalendarsEpic = action$ =>
  action$.ofType(actions.fetchGoogleCalendars.toString()).switchMap(() => {
    return meetingApi
      .fetchGoogleCalendars()
      .map(response => actions.fetchGoogleCalendarsSuccess(response))
      .startWith(actions.fetchGoogleCalendarsPending())
      .catch(error => Observable.of(actions.fetchGoogleCalendarsFailure()))
  })

const updateGoogleCalendarEpic = action$ =>
  action$.ofType(actions.updateGoogleCalendar.toString()).switchMap(action => {
    return meetingApi
      .updateGoogleCalendar(action.payload)
      .map(response => actions.updateGoogleCalendarSuccess(action.payload))
      .startWith(actions.updateGoogleCalendarPending(action.payload))
      .catch(error => Observable.of(actions.updateGoogleCalendarFailure()))
  })

const triggerFetchMicrosoftCalendarsEpic = action$ =>
  action$
    .ofType(actions.fetchCalendarStatusSuccess.toString())
    .filter(action => action.payload.microsoftAuthed)
    .map(() => actions.fetchMicrosoftCalendars())

const fetchMicrosoftCalendarsEpic = action$ =>
  action$.ofType(actions.fetchMicrosoftCalendars.toString()).switchMap(() => {
    return meetingApi
      .fetchMicrosoftCalendars()
      .map(response => actions.fetchMicrosoftCalendarsSuccess(response))
      .startWith(actions.fetchMicrosoftCalendarsPending())
      .catch(error => Observable.of(actions.fetchMicrosoftCalendarsFailure()))
  })

const updateMicrosoftCalendarEpic = action$ =>
  action$.ofType(actions.updateMicrosoftCalendar.toString()).switchMap(action => {
    return meetingApi
      .updateMicrosoftCalendar(action.payload)
      .map(response => actions.updateMicrosoftCalendarSuccess(action.payload))
      .startWith(actions.updateMicrosoftCalendarPending(action.payload))
      .catch(error => Observable.of(actions.updateMicrosoftCalendarFailure()))
  })

const updateMeetingSetting = action$ =>
  action$.ofType(
    actions.updateMicrosoftCalendar.toString(),
    actions.updateGoogleCalendarSuccess.toString())
    .switchMap(() => {
      return meetingApi
        .updateMeetingSettings()
        .map(() => actions.updateMeetingSettingsSuccess())
        .catch(() => Observable.of(actions.updateMeetingSettingsFailure()))
    })

const fetchDefaultMeetingSettings = action$ =>
  action$
    .ofType(actions.fetchDefaultMeetingSettings.toString())
    .mergeMap(() => {
      return meetingApi
        .fetchDefaultMeetingSettings()
        .map(response => actions.fetchDefaultMeetingSettingsSuccess(response))
        .startWith(actions.fetchDefaultMeetingSettingsPending())
        .catch(error => Observable.of(actions.fetchDefaultMeetingSettingsFailure()))
    })
    
const debouncedUpdateDefaultMeetingSettingsEpic = action$ =>
  action$
    .ofType(actions.updateDefaultMeetingSettings.toString())
    .debounceTime(500)
    .pluck('payload')
    .switchMap(payload => {
      return meetingApi
        .updateMeetingSettings(payload)
        .map(newDefault => actions.updateDefaultMeetingSettingsSuccess(newDefault))
        .startWith(actions.updateDefaultMeetingSettingsPending())
        .catch(error => Observable.of(actions.updateDefaultMeetingSettingsFailure(error)))
    })

export const epic = combineEpics(
  fetchCalendarStatusEpic,
  triggerFetchGoogleCalendarsEpic,
  fetchGoogleCalendarsEpic,
  updateGoogleCalendarEpic,
  triggerFetchMicrosoftCalendarsEpic,
  fetchMicrosoftCalendarsEpic,
  updateMicrosoftCalendarEpic,
  updateMeetingSetting,
  fetchDefaultMeetingSettings,
  debouncedUpdateDefaultMeetingSettingsEpic,
)
